import api from './api';

// Plan service for API communication (Admin only)
const planService = {
  // Get all plans
  getPlans: async (activeOnly = false) => {
    try {
      const params = activeOnly ? { active_only: true } : {};
      const response = await api.get('/api/plans', { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get a specific plan
  getPlan: async (id) => {
    try {
      const response = await api.get(`/api/plans/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Create a new plan
  createPlan: async (planData) => {
    try {
      const response = await api.post('/api/plans', planData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Update an existing plan
  updatePlan: async (id, planData) => {
    try {
      const response = await api.put(`/api/plans/${id}`, planData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Delete a plan
  deletePlan: async (id) => {
    try {
      const response = await api.delete(`/api/plans/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Delete a specific configuration from a plan
  deleteConfig: async (planId, configKey) => {
    try {
      const response = await api.delete(`/api/plans/${planId}/configs/${configKey}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default planService;
